import type {WorkspaceMobileBottomCreateItem} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceMobileBottomCreateItem";
import {
    DULUX__APPOINTMENT__LOG__FORM__ID,
    DULUX__APPOINTMENT__SCHEDULE__FORM__ID,
    DULUX__CALL__LOG__FORM__ID,
    DULUX__CALL__SCHEDULE__FORM__ID,
} from "~/domainModels/workspaceSpecific/dulux";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

const DULUX__UI__SCHEDULE_CALL_SHEET__ID = "e35cf8a1-3b4c-4d5e-9f60-b2c3d4e5f6a1" as Uuid;
const DULUX__UI__LOG_CALL_SHEET__ID = "f46df9b2-4c5d-4e6f-a071-b2c3d4e5f6072" as Uuid;
const DULUX__UI__SCHEDULE_APPOINTMENT_SHEET__ID = "a57ef0c3-5d6e-4f7a-b182-c3d4e5f60718" as Uuid;
const DULUX__UI__LOG_APPOINTMENT_SHEET__ID = "b68ff1d4-6e7f-408b-c293-d4e5f6071829" as Uuid;

/**
 * Default mobile Create sheet for Dulux when `workspaceUi.configuration.mobileBottomCreateSheet` is omitted.
 */
export const DULUX_DEFAULT_MOBILE_BOTTOM_CREATE_SHEET: readonly WorkspaceMobileBottomCreateItem[] = [
    {
        id: DULUX__UI__SCHEDULE_CALL_SHEET__ID,
        formId: DULUX__CALL__SCHEDULE__FORM__ID,
        formUrl: "dulux/call/schedule",
        iconId: "scheduleCall",
        displayName: "Schedule a call",
    },
    {
        id: DULUX__UI__LOG_CALL_SHEET__ID,
        formId: DULUX__CALL__LOG__FORM__ID,
        formUrl: "dulux/call/log",
        iconId: "logCall",
        displayName: "Log a call",
    },
    {
        id: DULUX__UI__SCHEDULE_APPOINTMENT_SHEET__ID,
        formId: DULUX__APPOINTMENT__SCHEDULE__FORM__ID,
        formUrl: "dulux/appointment/schedule",
        iconId: "scheduleCall",
        displayName: "Schedule appointment",
    },
    {
        id: DULUX__UI__LOG_APPOINTMENT_SHEET__ID,
        formId: DULUX__APPOINTMENT__LOG__FORM__ID,
        formUrl: "dulux/appointment/log",
        iconId: "logCall",
        displayName: "Log an appointment",
    },
];
